import { render, staticRenderFns } from "./WebStats.vue?vue&type=template&id=1457f406&scoped=true&"
import script from "./WebStats.vue?vue&type=script&lang=js&"
export * from "./WebStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1457f406",
  null
  
)

export default component.exports